export const MAX_QUERY_LENGTH = 1500
